import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let theme = createTheme({
  palette: {
    primary: {
      main: '#702572',
    },
    secondary: {
      main: '#00a99d',
    },
    grey: {
      main: '#283c3c',
    },
  },
  typography: {
    fontFamily: 'Questrial',
    color: '#702572',
  },
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          color: '#702572',
          '& label + div': {
            alignItems: 'flex-end',
            '&[role="radiogroup"]': {
              alignItems: 'flex-start',
            },
            paddingBottom: 4,
            '& input, > div, > select': {
              padding: '24px 8px 0',
            },
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        endAdornment: {
          padding: '0 !important',
        },
        root: {
          border: '1px solid #702572',
          borderRadius: 8,
          alignItems: 'center',
          transition: 'border 0.3s ease',
        },
        input: {
          padding: 10,
          fontSize: 14,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          padding: '14px 12px 3px 6px !important',
        },
        notchedOutline: {
          top: '0px',
          '&>legend': {
            float: 'left',
          },
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          padding: '0 !important',
          margin: '0 10px 0 0',
          height: '100%',
        },
      },
    },
    MuiStep: {
      styleOverrides: {
        root: {
          paddingLeft: '7px',
          paddingRight: '8px',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          // overflow: 'hidden',
          border: '1px solid #702572',
          borderBottom: '3px solid #702472',
          borderRadius: 8,
          alignItems: 'center',
          transition: 'border 0.3s ease',
        },
        underline: {
          '&[role="radiogroup"]': {
            alignItems: 'flex-start',
          },
          '&:after': {
            height: 'calc(100% + 1px)',
            borderRadius: 8,
            bottom: -1,
            boxShadow: `0 0 1px #702572`,
          },
          '&:before': {
            display: 'none',
          },
        },
        input: {
          padding: 10,
          fontSize: 14,
        },
        multiline: {
          paddingTop: 24,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#702572',
          '& + div': {
            alignItems: 'flex-end',
          },
          margin: '5px 0px !important',
        },
        formControl: {
          top: 12,
          left: 10,
          transform: 'translate(0, 22px) scale(1)',
        },
        shrink: {
          transform: 'translate(0, 13px) scale(0.7)',
          zIndex: 1,
        },
        filled: {
          transform: 'translate(2px, 6px) scale(1)',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(0px, -6px) scale(0.75)',
          },
        },
        outlined: {
          transform: 'translate(2px, 6px) scale(1)',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(4px, -16px) scale(0.75)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          boxShadow: 'none',
        },
        root: {
          borderRadius: 20,
          fontWeight: 600,
        },
        sizeSmall: {
          padding: '7px 12px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          borderColor: '#702572',
        },
        icon: {
          top: 'calc(50% - 10px)',
          right: 0,
        },
        selectMenu: {
          paddingRight: '24px',
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
